import * as tslib_1 from "tslib";
import { RelevanceFormControl } from "../../../../../../form/src/common/controls/relevance-form-control";
import { ReverseRelevanceControl } from "../../../../../../form/src/common/controls/reverse-relevance-control";
import { ReverseQueryService } from '../../../../../../form/src/common/services';
import SearchPanel from "../../../../../../form/src/components/RelevanceForm/components/mobile-relevance-form/search-panel.vue";
import { H3Avatar, H3Checkbox } from 'h3-mobile-vue';
import { Component, Inject, Model, Prop } from "vue-property-decorator";
let ReverseRelevanceTabs = class ReverseRelevanceTabs extends ReverseRelevanceControl {
    constructor() {
        super(...arguments);
        this.queryConditions = [];
        this.queryActions = [];
        this.param = [];
        this.showPanel = true;
        this.queryColumns = [];
    }
    get hasAdd() {
        return this.queryActions.find(x => x.actionCode === 'add');
    }
    // relevanceForm:any = new RelevanceForm();
    // @Watch("visible")
    created() {
        const schemaCode = this.controlOpts.schemaCode || '';
        const listCode = this.controlOpts.listCode || '';
        const conditions = this.controlOpts.mobileConditions;
        const formControls = this.getFormControls();
        const c = this.control;
        const param = ReverseQueryService.getParams(conditions, formControls, c, this.findController);
        this.param = param;
        ReverseQueryService.getListQueryConditions(schemaCode, listCode, param).then(res => {
            this.queryConditions = res.conditions || [];
            this.queryActions = res.queryActions || [];
            this.queryColumns = res.queryColumns || [];
        });
    }
    mounted() {
        this.emitScrollLock(true);
        window.sessionStorage.removeItem('fullPath');
    }
    isSelected(item) {
        if (!this.value || !item) {
            return false;
        }
        return this.value.id === item.id;
    }
    back() {
        this.$emit('back');
    }
    getCreater(item) {
        if (Array.isArray(item.creater)) {
            if (item.creater.length > 0) {
                return item.creater[0];
            }
        }
        return {};
    }
    // async change(item: any) {
    //   item = await this.convertForMappings(item);
    //   this.$emit("change", item);
    // }
    superFetch(page, pageSize, value, formStatus) {
        const schemaCode = this.controlOpts.schemaCode || '';
        const listCode = this.controlOpts.listCode || '';
        let params = this.queryFormData ? this.queryFormData : this.param;
        params = params.map((res) => {
            let code = res.propertyCode !== undefined ? res.propertyCode : res.code;
            let type = res.propertyType !== undefined ? res.propertyType : res.type;
            let val = res.propertyValue !== undefined ? res.propertyValue : res.value;
            return {
                code,
                type,
                value: val
            };
        });
        if (formStatus) {
            const status = {
                code: formStatus.propertyCode,
                type: formStatus.propertyType,
                value: formStatus.propertyValue
            };
            params.push(status);
        }
        return this.fetch(page, pageSize, value, params);
    }
    getStatus(status) {
        const txt = this.$t(`cloudpivot.form.renderer.formStatus.${status.toLowerCase()}`);
        return txt;
        // switch (status) {
        //   case "DRAFT":
        //     return "草稿";
        //   case "PROCESSING":
        //     return "进行中";
        //   case "COMPLETED":
        //     return "已完成";
        //   case "CANCELED":
        //     return "已作废";
        //   default:
        //     return "";
        // }
    }
    showFilterPanel(show) {
        this.showPanel = !show;
    }
    onFilter(query) {
        this.showPanel = true;
        // this.queryFormData = query.map(x => ({
        //   code : x.propertyCode,
        //   type : x.propertyType,
        //   value : x.propertyValue
        // }));
        this.queryFormData = query;
        const searchPanel = this.$refs.searchPanel;
        if (searchPanel) {
            searchPanel.reFetch();
        }
    }
    beforeCreate() {
        this.$options.components.FormStatus = RelevanceFormControl.loadFormStatus();
        this.$options.components.QueryForm = RelevanceFormControl.loadQueryForm();
        this.$options.components.FormItem = RelevanceFormControl.loadFormItem();
    }
    openForm() {
        const ac = this.queryActions.find(x => x.actionCode === 'add');
        if (!ac)
            return;
        const fieldCode = this.controlOpts.fieldCode;
        const sheetParams = this.controlOpts.sheetParams;
        let sequenceStatus = {};
        if (this.sequenceStatus && this.sequenceStatus !== 'DRAFT') {
            sequenceStatus[fieldCode] = sheetParams.id;
        }
        this.emitScrollLock(false);
        // 保存地址,等到提交表单之后返回当前页面
        window.sessionStorage.setItem('fullPath', this.$route.fullPath);
        if (ac.associationType === 1) { // 流程表单
            this.$router.push({
                name: 'form-detail',
                query: Object.assign({ startWorkflowCode: ac.associationCode }, sequenceStatus)
            }).catch((err) => { err; });
        }
        else {
            this.$router.push({
                name: 'form-detail',
                query: Object.assign({ schemaCode: ac.schemaCode, sheetCode: ac.associationCode }, sequenceStatus)
            }).catch((err) => { err; });
        }
        //防止页面跳转后ui未更新
        window.location.reload();
    }
    openItem(item) {
        super.open(item);
    }
};
tslib_1.__decorate([
    Prop({
        default: false
    })
], ReverseRelevanceTabs.prototype, "visible", void 0);
tslib_1.__decorate([
    Model("change")
], ReverseRelevanceTabs.prototype, "value", void 0);
tslib_1.__decorate([
    Inject()
], ReverseRelevanceTabs.prototype, "emitScrollLock", void 0);
ReverseRelevanceTabs = tslib_1.__decorate([
    Component({
        name: "relevance-form-tabs",
        components: {
            SearchPanel,
            H3CheckboxItem: H3Checkbox.Item,
            H3Avatar,
        },
        directives: {
        // TransferDom
        }
    })
], ReverseRelevanceTabs);
export default ReverseRelevanceTabs;
